/**
 * Custom JavaScript – Casa & Style
 * Código limpo e otimizado para melhor performance
 */

/* =========================
   Scroll to Top (Mobile)
========================= */
if (window.matchMedia("(max-width: 768px)").matches) {
  window.addEventListener("scroll", function () {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
    var btn = document.getElementById("scrollToTop");

    if (btn) {
      btn.style.display = pageOffset > 1200 ? "block" : "none";
    }
  });
}

/* =========================
   Parcelamento
========================= */
function parcelamento() {
  var precoTexto = document.querySelector('.product-form__info-item .price--highlight');
  var compareTexto = document.querySelector('.product-form__info-item .price--compare');

  if (!precoTexto) return;

  var preco = precoTexto.innerText
    .replace('R$', '')
    .replace(',', '.')
    .trim();

  preco = parseFloat(preco);

  if (compareTexto) {
    var compare = compareTexto.innerText
      .replace('R$', '')
      .replace(',', '.')
      .trim();

    compare = parseFloat(compare);

    if (!isNaN(compare) && compare > preco) {
      var descontoValor = (compare - preco).toFixed(2).replace('.', ',');
      var porcentagem = ((compare - preco) * 100 / compare).toFixed(0);

      var label = document.querySelector('.product-label.product-label--on-sale span');
      if (label) {
        label.innerText = 'R$ ' + descontoValor;
      }

      var badge = document.querySelector('.price--highlight .product-label.product-label--on-sale');
      if (badge && !badge.innerHTML.includes('%')) {
        badge.innerHTML += ' -' + porcentagem + '%';
      }
    }
  }

  var parcela = ((preco * 1.1979) / 12).toFixed(2).replace('.', ',');
  var container = document.querySelector('.parcelamento');

  if (container) {
    container.innerHTML = '<span>em até 12x de <b>R$ ' + parcela + '</b></span>';
  }
}

/* =========================
   Atualizar ao trocar variante
========================= */
document.addEventListener("change", function (e) {
  if (e.target.classList.contains("block-swatch__radio")) {
    setTimeout(parcelamento, 150);
  }
});

/* =========================
   Rodar ao carregar página
========================= */
document.addEventListener("DOMContentLoaded", function () {
  parcelamento();
});
document.addEventListener("scroll", function () {
  const bar = document.getElementById("stickyBuyBar");
  const buyButton = document.querySelector('form[action*="/cart/add"]');

  if (!bar || !buyButton) return;

  const buttonPosition = buyButton.getBoundingClientRect().top;

  if (buttonPosition < 0) {
    bar.style.display = "block";
  } else {
    bar.style.display = "none";
  }
});
